import React, { useCallback, Fragment } from 'react';
import PropTypes from 'prop-types';
import { NakedButton } from 'roo-ui/components';
import MapWithMarker from 'components/maps/MapWithMarker';
import { useDataLayer } from 'hooks/useDataLayer';
import Modal from 'components/Modal';
import { useModal } from 'lib/hooks';
import styled from '@emotion/styled';

// NOTE: This tweak could probably be moved into Roo-ui
const Button = styled(NakedButton)`
  max-width: 100%;
`;

const MapWithMarkerButton = ({ latitude, longitude, locationName, children }) => {
  const { openModal, modalProps } = useModal();
  const { emitInteractionEvent } = useDataLayer();

  const handleOpenModal = useCallback(() => {
    openModal();
    emitInteractionEvent({ type: 'Map View', value: `Map Picture Selected` });
  }, [emitInteractionEvent, openModal]);

  return (
    <Fragment>
      <Button onClick={handleOpenModal} data-testid="show-map-button">
        {children}
      </Button>
      {modalProps.isOpen && (
        <Modal {...modalProps} fullScreen padding="0" title={locationName}>
          <MapWithMarker name="map-with-marker" data-testid="map-with-marker" latitude={latitude} longitude={longitude} />
        </Modal>
      )}
    </Fragment>
  );
};

MapWithMarkerButton.propTypes = {
  latitude: PropTypes.number.isRequired,
  longitude: PropTypes.number.isRequired,
  locationName: PropTypes.string.isRequired,
  small: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

MapWithMarkerButton.defaultProps = {
  small: false,
};
export default MapWithMarkerButton;
